export const SKELETON_ROLES_COUNT = 5;
export const SKELETON_PERMISSIONS_COUNT = 8;

export const ROLE_NAME_REQUIRED_ERROR = 'Role name is required';
export const ROLE_ALREADY_EXISTS_ERROR = 'Role already exists';
export const ROLE_PERMISSION_REQUIRED_ERROR = 'Select at least one permission';
